// extracted by mini-css-extract-plugin
export default {"awardList":"CompetitionOverview_awardList__GK62v"};